// extracted by css-extract-rspack-plugin
export default {"header":"EmployeeDetailsPage_header__lED1E","headerTitleWrapper":"EmployeeDetailsPage_headerTitleWrapper__jmjeK","main":"EmployeeDetailsPage_main__B8gEr"};